import { apiSlice } from './apiSlice'

export enum RoundType {
  TRAINING = 'training',
  MEMORIAL = 'memorial',
  ONLINE_HEARING = 'online_hearing',
  FINAL = 'final',
}

export enum RoundStatus {
  UPCOMING = 'upcoming',
  ACTIVE = 'active',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

export interface Round {
  id: string
  case_id: string  // Case ID (Cuộc thi) mà vòng thi này thuộc về
  name: string
  round_type: RoundType
  start_date: string
  end_date: string
  status: RoundStatus
  description?: string
  meeting_link?: string  // Google Meet link for online hearing
  created_at?: string
  updated_at?: string
  created_by?: string
}

export interface RoundCreate {
  case_id: string  // Case ID (Cuộc thi) mà vòng thi này thuộc về
  name: string
  round_type: RoundType
  start_date: string
  end_date: string
  status?: RoundStatus
  description?: string
}

export interface RoundUpdate {
  case_id?: string
  name?: string
  round_type?: RoundType
  start_date?: string
  end_date?: string
  status?: RoundStatus
  description?: string
  meeting_link?: string
}


export interface RoundDashboard {
  round: Round
  statistics: {
    total_cases: number
    total_teams: number
    status_counts: Record<string, number>
  }
  cases: any[]
}

export const roundsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRounds: builder.query<Round[], { case_id?: string } | void>({
      query: (params) => {
        if (params && params.case_id) {
          return `/rounds?case_id=${params.case_id}`
        }
        return '/rounds'
      },
      providesTags: ['Round'],
    }),
    getRound: builder.query<Round, string>({
      query: (id) => `/rounds/${id}`,
      providesTags: (result, error, id) => [{ type: 'Round', id }],
    }),
    createRound: builder.mutation<Round, RoundCreate>({
      query: (body) => ({
        url: '/rounds',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Round'],
    }),
    updateRound: builder.mutation<Round, { id: string } & RoundUpdate>({
      query: ({ id, ...data }) => ({
        url: `/rounds/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Round', id }],
    }),
    deleteRound: builder.mutation<void, string>({
      query: (id) => ({
        url: `/rounds/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Round'],
    }),
    getCaseRounds: builder.query<Round[], string>({
      query: (caseId) => `/cases/${caseId}/rounds`,
      providesTags: (result, error, caseId) => [
        { type: 'Round' },
        { type: 'Case', id: caseId },
      ],
    }),
  }),
})

export const {
  useGetRoundsQuery,
  useGetRoundQuery,
  useCreateRoundMutation,
  useUpdateRoundMutation,
  useDeleteRoundMutation,
  useGetCaseRoundsQuery,
} = roundsApi
